import MaterialTable from "material-table";
import React, { useReducer, useState, useEffect, useContext } from "react";
import tableReducer, { INITIAL_TABLE_STATE } from "reducers/table_reducer";
import tableIcons, { options } from "components/universal/table_attributes";
import TableAction from "actions/table_actions";
import { IconButton } from "@material-ui/core";
import AdditionalData from "./AdditionalData";
import useDebounce from "lib/utils/debounce";
import { ToastMessageContext } from "lib/contexts/message_context";
import CopyFileIcon from "assets/CopyFiles.svg"
import GreenCopyIcon from "assets/GreenCopyIcon.svg"
import ViewIcon from "@material-ui/icons/Visibility";
import { ICON_COLOUR } from "lib/constants/style_constants";

import { WorkshopContext } from "views/Operations/Workshop/WorkshopContext/WorkshopContext";
import alertIcon from 'assets/icons/Alert_icon.png'
import TechFilesPopup from "./TechFilesPopup";


function Services(props) {

  const { currentClosedDetails, currentPlanningDetails, copyTab } = props
  const [searchText, setSearchText] = useState("");
  const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
  const { page, totalCount, pageSize, data, inProgress } = tableState;
  const [action, setAction] = useState(false)
  const message = useContext(ToastMessageContext);
  const { copyServiceTabStatus, serviceStatus } = useContext(WorkshopContext)
  const debouncedVal = useDebounce(searchText);
  const [selectedRow, setSelectedRow] = useState({});
  const [isTechFiles, setIsTechFiles] = useState(false)
  const [currentSelectedRow, setCurrentSelectedRow] = useState({})

  const getServices = () => {
    const params = {
      count_per_page: pageSize,
      page: page + 1,
      workshop_order_id: currentClosedDetails?.id,
      search_keyword: debouncedVal,
    };
    TableAction.getList(dispatch, message, params, "workshopServices");
  }

  useEffect(() => {
    getServices();
  }, [page, pageSize, debouncedVal]);


  const tableOptions = {
    ...options,
    page: page,
    total: totalCount,
    pageSize: pageSize,
    search: false,
    toolbar: false
  };

  const columns = [
    {
      title: "Action #",
      field: "workshop_action_number",
      headerStyle: {
        textAlign: "left",
        paddingLeft: "20px"
      },
      cellStyle: {
        textAlign: "left",
        paddingLeft: "20px"
      },
    },
    {
      title: "Category",
      field: "scope",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      title: "Type",
      field: "service_type",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      title: "Description",
      field: "description",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        width: "30%",
      },
    },
    {
      title: "Location",
      field: "location",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (rowData) => {
        if (rowData?.location === "mro_on_site") return "MRO Site"
        else if (rowData?.location === "supplier_off_site") {
          return "Supplier Site"
        }
      }
    },

    {
      title: "Tech Data",
      // field: "tech_data",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (rowData) => (
        <div>
          <IconButton>
            <ViewIcon fontSize="small" style={{ color: ICON_COLOUR }} onClick={() => {
              setIsTechFiles(true)
              setAction("view_files")
              setCurrentSelectedRow(rowData)
            }}
            />
          </IconButton>

        </div>

      )
    },
    {
      title: "Action",
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (rowData) => (
        <div>
          <IconButton
            onClick={() => {
              setAction("View");
              setSelectedRow(rowData);
              copyServiceTabStatus.push(rowData.id)
            }}
            disabled={serviceStatus && copyServiceTabStatus.find((item) => item === rowData.id)}
          >
            {serviceStatus && copyServiceTabStatus.find((item) => item === rowData.id) ? <img src={GreenCopyIcon} height="25px" style={{ pointerEvents: serviceStatus && copyServiceTabStatus.find((item) => item === rowData.id) ? "none" : "" }} /> :

              <img src={CopyFileIcon} height="25px" />
            }
          </IconButton>
        </div>
      ),
    },
  ];
  return (
    <div>

      <MaterialTable
        style={{
          boxShadow: "0px 1px 3px #00000033",
          marginTop: "10px",
        }}
        icons={tableIcons}
        title={""}
        columns={columns}
        data={data?.data || []}
        isLoading={inProgress}
        options={tableOptions}
        onChangePage={(page) => {
          TableAction.setPage(dispatch, page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          TableAction.setPageSize(dispatch, pageSize);
        }}
        totalCount={totalCount}
        page={page}
      />
      <ul style={{ listStyleType: 'none', margin: ' 14px 0px 20px -33px' }}>
        <li style={{ marginBottom: '6px' }}>
          <img src={alertIcon} height="15px" /> <span style={{ padding: '6px' }}> Copy Actions first! Parts must be associated to a new Action in the 'To' Order</span> </li>
        <li style={{ marginBottom: '6px' }}>
          <img src={alertIcon} height="15px" /> <span style={{ padding: '6px' }}> Tech Data will be copied. Check for correct revision and update as necessary in the 'To' Order after copying</span> </li>
        <li style={{ marginBottom: '6px' }}>
          <img src={alertIcon} height="15px" /> <span style={{ padding: '6px' }}> Supplier Site services must have a Part # and Serial # added in the Service Request in the 'To' Order after copying</span></li>
      </ul >
      {action && action === "View" && <AdditionalData handleClose={() => setAction(null)} currentClosedDetails={currentClosedDetails} currentPlanningDetails={currentPlanningDetails} selectedRow={selectedRow} copyTab={copyTab} />
      }

      {
        action === 'view_files' && (
          <TechFilesPopup
            handleClose={() => setAction(null)}
            currentSelectedRow={currentSelectedRow}
            open={isTechFiles}
          />
        )
      }
    </div >
  );
}

export default Services;
